module.exports = __webpack_public_path__ + "img/hourglass-03.f8a590f1.svg";